// export const BASE_URL_API = "https://cors-anywhere.herokuapp.com/https://business.stylelink.in/apis/";
export const BASE_URL_API = "https://business.stylelink.in/apis/";